import { APICall } from '.'

export const ax_auth_login = async data => {
  try {
    const res = await APICall.post(`/loginRouter/login`, data)
    // console.log("Login Response:", res);
    // console.log("Login Data:", data);

    if (res.data.code === 200) {
      return res.data
    } else if (!res.data.success) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('Login API Error:', error)
    return error
  }
}

export const ax_auth_addUser = async data => {
  try {
    const res = await APICall.post(`/addUser/addUserData`, data)
    console.log('User Response:', res)
    console.log('user Data:', data)

    if (res.data.code === 200) {
      return res.data
    } else if (!res.data.success) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('Add user API Error:', error)
    return error
  }
}

export const ax_auth_forgotPass = async data => {
  try {
    const res = await APICall.post(`/loginRouter/forgotPassword`, data)
    console.log('FG Response:', res)
    console.log('FG Data:', data)

    if (res.data.code === 200) {
      return res.data
    } else if (!res.data.success) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('Forgotpass API Error:', error)
    return error
  }
}

export const ax_auth_resetPass = async data => {
  try {
    const res = await APICall.post(`/loginRouter/resetPassword`, data)
    console.log('FG Response:', res)
    console.log('FG Data:', data)

    if (res.data.code === 200) {
      return res.data
    } else if (!res.data.success) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('Forgotpass API Error:', error)
    return error
  }
}

// export const fetchClaimRecord = async (getId, setInvoiceWarr) => {
//   if (!getId) {
//     console.warn('getId is undefined. Skipping API call.')
//     return
//   }

//   try {
//     const response = await APICall.post(
//       '/claimWarr/claimRecord',
//       { getId }
//     )

//     const invoiceData = response?.data?.data?.invoiceFile
//     setInvoiceWarr(invoiceData)
//   } catch (error) {
//     console.error('Error fetching claim record:', error)
//   }
// }

// export const handleLogout = async (
//   navigate,
//   setIsPopupShow,
//   setShowSidebar
// ) => {
//   try {
//     const response = await APICall.post(
//       'log/logOut',
//       {
//         withCredentials: true
//       }
//     )

//     if (response?.data?.success) {
//       localStorage.clear()
//       sessionStorage.clear()
//       navigate('/auth')
//     } else if (response?.data?.error) {
//       console.error('Logout failed:', response.data.error)
//     }
//   } catch (error) {
//     console.error('Error during logout:', error)
//   } finally {
//     setIsPopupShow(false)
//     setShowSidebar(false)
//   }
// }

export const fetchClaimRecord = async (getId, setInvoiceWarr) => {
  if (!getId) {
    console.warn('getId is undefined. Skipping API call.')
    return
  }

  try {
    const response = await APICall.post('claimWarr/claimRecord', { getId })

    if (response?.data?.data?.invoiceFile) {
      setInvoiceWarr(response.data.data.invoiceFile)
    } else {
      console.warn('No invoice file found in response.')
    }
  } catch (error) {
    console.error('Error fetching claim record:', error)
  }
}

export const handleLogout = async (
  navigate,
  setIsPopupShow,
  setShowSidebar
) => {
  try {
    const response = await APICall.post('log/logOut', { withCredentials: true })

    if (response?.data?.success) {
      localStorage.clear()
      sessionStorage.clear()
      navigate('/auth')
    } else {
      console.error('Logout failed:', response?.data?.error || 'Unknown error')
    }
  } catch (error) {
    console.error('Error during logout:', error)
  } finally {
    setIsPopupShow(false)
    setShowSidebar(false)
  }
}
